import { useContext } from "react";
import { AppContext } from "../App";
import QrIcon from "../icons/QrIcon";
import SellsIcon from "../icons/SellsIcon";
import LightModeLockedPopup from "./LightModeLockedPopup";

export default function HeaderRight() {
	const {
		shop,
		lightMode,
		iframeMode,
		setOrdersListVisible,
		orders,
		sells,
		tables,
		setTablesListVisible,
		setQrScanPopupVisible,
		setSellsListVisible,
		setPopup,
	} = useContext(AppContext);

	const openLightModeLockedPopup = () => {
		setPopup({
			hideHeader: true,
			customClass: "lightmode-locked-popup",
			content: <LightModeLockedPopup />,
		});
	};

	const hasSellsReceiptError = (sells || []).some((sell) => {
		const hasReceiptError =
			Number(sell?.bill) === 2 || String(sell?.status || "") === "payment_error";
		const hasThermalPrintError = (sell?.thermal_print_results || []).some(
			(res) => Number(res?.success) === 0,
		);
		const hasInvoiceError =
			sell?.invoice == 1 &&
			sell?.invoice_result != null &&
			(sell.invoice_result?.service_response?.errorCode !== "0000" ||
				sell.invoice_result?.aruba_response?.status !== "inviata");
		return hasReceiptError || hasThermalPrintError || hasInvoiceError;
	});

	const hasOrdersPrintError = (orders || []).some((order) => {
		if (String(order?.status || "").trim().toLowerCase() === "archived") return false;
		return (order?.thermal_print_results || []).some((res) => Number(res?.success) === 0);
	});
	const tablesRows = Array.isArray(tables) ? tables : [];

	return (
		<div className="header-right">
			<button
				className={lightMode ? "is-disabled has-info-hint" : ""}
				onClick={() => (lightMode ? openLightModeLockedPopup() : setTablesListVisible(true))}
			>
				<div className="badge">
					{tablesRows.filter((t) => t.shop_id == shop.id && t.status != 0).length}
				</div>
				Tavoli
			</button>
			{orders && (
				<button
					onClick={() => setOrdersListVisible(true)}
					className={hasOrdersPrintError ? "attention-pulse" : ""}
				>
					<div className="badge">{orders.length}</div>
					Ordini
				</button>
			)}
			<button
				className={"icon-button" + (hasSellsReceiptError ? " attention-pulse" : "")}
				onClick={() => setSellsListVisible(true)}
			>
				<SellsIcon />
			</button>
			<button className="icon-button" onClick={() => setQrScanPopupVisible(true)}>
				<QrIcon />
			</button>
			{iframeMode && (
				<button
					className="header-close-button"
					onClick={() => {
						window.parent.postMessage("close", "*");
					}}
				>
					&times;
				</button>
			)}
		</div>
	);
}
